import { ActionButton, Text } from '@react-spectrum/s2';
import ChevronLeft from '@react-spectrum/s2/icons/ChevronLeft';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };
import { memo } from 'react';

import { cn } from '@/utils/cn.ts';

interface SpaceLayoutProps {
	title: string;
	children: React.ReactNode;
	onBack?: () => void;
	className?: string;
	style?: React.CSSProperties;
	fillHeight?: boolean;
}

const titleTextStyles = style({
	font: 'title',
	color: 'body',
	fontSize: 'title',
	fontWeight: 'bold',
});

export const SpaceLayout = memo(function SpaceLayout({
	title,
	children,
	onBack,
	className,
	style,
	fillHeight,
}: SpaceLayoutProps) {
	return (
		<div
			className={cn(
				'md:glass-panel flex h-full w-full flex-col overflow-hidden',
				className,
			)}
			style={style}
		>
			{onBack && (
				<div
					className={cn(
						'glass-panel-header flex min-h-12 items-center gap-3 px-4 py-3',
					)}
				>
					<ActionButton isQuiet onPress={onBack} aria-label="Back">
						<ChevronLeft />
					</ActionButton>
					<Text styles={titleTextStyles}>{title}</Text>
				</div>
			)}
			{!onBack && (
				<div
					className="flex min-h-12 items-center gap-3 px-4 pb-3 md:hidden"
					style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top))' }}
				>
					<div className="w-8" aria-hidden />
					<div className="flex flex-1 items-center justify-center">
						<Text styles={titleTextStyles}>{title}</Text>
					</div>
					<div className="w-8" aria-hidden />
				</div>
			)}
			<div className="flex min-w-0 flex-1 overflow-hidden">
				<div className="flex min-w-0 flex-1 flex-col overflow-hidden">
					<div
						className={cn(
							'flex-1',
							fillHeight
								? 'flex min-h-0 flex-col overflow-hidden'
								: 'overflow-y-auto',
						)}
					>
						<div
							className={cn(
								`mx-auto flex w-full max-w-4xl flex-col px-2 pt-2 md:px-6
								md:pt-6`,
								fillHeight ? '' : 'pb-16',
								fillHeight ? 'min-h-0 flex-1' : 'min-h-full',
							)}
						>
							{children}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
